import PropTypes from 'prop-types';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { isNilOrEmpty } from 'ramda-extension';

import { getLabelMessage } from '@gef-ui/localization/messages';

import SectionHeader from 'components/atoms/GefMui/SectionHeader';
import SingleNote from 'components/atoms/GefMui/SingleNote';

export const Notes = ({ comments }) => (
	<Paper sx={{ p: 3, borderRadius: 2 }}>
		<Stack spacing={2}>
			<SectionHeader text={getLabelMessage('contactDetail:contactNotesSubheader')} />
			{!isNilOrEmpty(comments) && (
				<Stack spacing={5}>
					{comments.map((item) => (
						<SingleNote key={item?.id} id={item?.id} item={item} />
					))}
				</Stack>
			)}
		</Stack>
	</Paper>
);

Notes.propTypes = {
	comments: PropTypes.array,
};

export default Notes;
